import {
  Box,
  Chip,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

const overviewCards = [
  { label: 'Total Orders', value: '1,284', helper: '84 this month' },
  { label: 'Total Products', value: '126', helper: '18 active variants' },
  { label: 'Total Users', value: '892', helper: '57 new signups' },
  { label: 'Total Income', value: 'Rs 4.82L', helper: '12.4% growth' },
];

const recentOrders = [
  { id: '#4012', customer: 'Ravi Kumar', amount: 'Rs 540', status: 'Packed' },
  { id: '#4011', customer: 'Meena S', amount: 'Rs 280', status: 'Placed' },
  { id: '#4010', customer: 'Anu Guest', amount: 'Rs 250', status: 'Out for delivery' },
  { id: '#4009', customer: 'Swetha P', amount: 'Rs 890', status: 'Delivered' },
];

const yearlyOrderStats = [
  { month: 'Jan', value: 42 },
  { month: 'Feb', value: 51 },
  { month: 'Mar', value: 63 },
  { month: 'Apr', value: 58 },
  { month: 'May', value: 72 },
  { month: 'Jun', value: 66 },
  { month: 'Jul', value: 74 },
  { month: 'Aug', value: 81 },
  { month: 'Sep', value: 76 },
  { month: 'Oct', value: 88 },
  { month: 'Nov', value: 94 },
  { month: 'Dec', value: 90 },
];

const lowStockItems = [
  { name: 'Punjabi Papad 200g', stock: 8, variant: 'PUN-200' },
  { name: 'Jeera Papad 180g', stock: 5, variant: 'JEE-180' },
  { name: 'Mini Papad Combo', stock: 4, variant: 'MINI-CMB' },
  { name: 'Masala Fryums', stock: 9, variant: 'MAS-FRY' },
];

const topSellingProducts = [
  { name: 'Punjabi Papad', sold: '324 sold', trend: 'Top this month' },
  { name: 'Jeera Papad', sold: '281 sold', trend: 'Fast repeat orders' },
  { name: 'Mini Papad Combo', sold: '226 sold', trend: 'Strong combo sales' },
  { name: 'Pepper Appalam', sold: '204 sold', trend: 'Growing weekly' },
];

export default function AdminDashboard() {
  return (
    <Box className='admin-dashboard-overview'>
      <Grid container spacing={2.5} className='admin-dashboard-metrics'>
        {overviewCards.map((card) => (
          <Grid key={card.label} size={{ xs: 12, sm: 6, xl: 3 }}>
            <Paper className='admin-dashboard-metricCard' elevation={0}>
              <Typography className='admin-dashboard-metricLabel'>
                {card.label}
              </Typography>
              <Typography className='admin-dashboard-metricValue'>
                {card.value}
              </Typography>
              <Typography className='admin-dashboard-note'>
                {card.helper}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2.5}>
        <Grid size={{ xs: 12, lg: 5 }}>
          <Paper className='admin-dashboard-featureCard' elevation={0}>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={1.5}
              justifyContent='space-between'
              alignItems={{ xs: 'flex-start', sm: 'center' }}
            >
              <Box>
                <Typography className='admin-dashboard-cardKicker'>
                  Recent activity
                </Typography>
                <Typography className='admin-dashboard-cardTitle'>
                  Recent orders
                </Typography>
              </Box>
              <Chip label='Live queue' className='admin-dashboard-statusChip' />
            </Stack>

            <List className='admin-dashboard-dataList'>
              {recentOrders.map((order) => (
                <ListItem key={order.id} className='admin-dashboard-dataItem'>
                  <ListItemText
                    primary={`${order.id} - ${order.customer}`}
                    secondary={order.amount}
                  />
                  <Chip label={order.status} size='small' />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>

        <Grid size={{ xs: 12, lg: 7 }}>
          <Paper className='admin-dashboard-sideCard' elevation={0}>
            <Typography className='admin-dashboard-cardKicker'>
              Orders trend
            </Typography>
            <Typography className='admin-dashboard-cardTitle'>
              Yearly order stats
            </Typography>

            <Box className='admin-dashboard-chart'>
              {yearlyOrderStats.map((item) => (
                <Box key={item.month} className='admin-dashboard-chartItem'>
                  <Box
                    className='admin-dashboard-chartBar'
                    style={{ height: `${item.value}%` }}
                  />
                  <Typography className='admin-dashboard-chartValue'>
                    {item.value}
                  </Typography>
                  <Typography className='admin-dashboard-chartLabel'>
                    {item.month}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Paper>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <Paper className='admin-dashboard-featureCard' elevation={0}>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={1.5}
              justifyContent='space-between'
              alignItems={{ xs: 'flex-start', sm: 'center' }}
            >
              <Box>
                <Typography className='admin-dashboard-cardKicker'>
                  Inventory watch
                </Typography>
                <Typography className='admin-dashboard-cardTitle'>
                  Low stock items
                </Typography>
              </Box>
              <Chip label='Refill soon' className='admin-dashboard-statusChip' />
            </Stack>

            <List className='admin-dashboard-dataList'>
              {lowStockItems.map((item) => (
                <ListItem key={item.variant} className='admin-dashboard-dataItem'>
                  <ListItemText
                    primary={item.name}
                    secondary={`Variant: ${item.variant}`}
                  />
                  <Typography className='admin-dashboard-stockAlert'>
                    {item.stock} left
                  </Typography>
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <Paper className='admin-dashboard-sideCard' elevation={0}>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={1.5}
              justifyContent='space-between'
              alignItems={{ xs: 'flex-start', sm: 'center' }}
            >
              <Box>
                <Typography className='admin-dashboard-cardKicker'>
                  Sales movers
                </Typography>
                <Typography className='admin-dashboard-cardTitle'>
                  Top selling products
                </Typography>
              </Box>
              <Chip label='Best performers' className='admin-dashboard-statusChip' />
            </Stack>

            <List className='admin-dashboard-dataList'>
              {topSellingProducts.map((product) => (
                <ListItem key={product.name} className='admin-dashboard-dataItem'>
                  <ListItemText
                    primary={product.name}
                    secondary={product.trend}
                  />
                  <Typography className='admin-dashboard-salesValue'>
                    {product.sold}
                  </Typography>
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}
